import { useEffect, useRef, useCallback } from "react";

export function useScrollAnimation() {
  const ref = useRef(null);
  const observerRef = useRef(null);

  const setupObserver = useCallback(() => {
    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px -30px 0px" }
    );

    const elements = ref.current?.querySelectorAll(".fade-up:not(.visible)");
    elements?.forEach((el) => observerRef.current.observe(el));
  }, []);

  useEffect(() => {
    setupObserver();

    // MutationObserver to catch dynamically added elements
    const mutationObserver = new MutationObserver(() => {
      const newElements = ref.current?.querySelectorAll(".fade-up:not(.visible)");
      newElements?.forEach((el) => {
        if (observerRef.current) {
          observerRef.current.observe(el);
        }
      });
    });

    if (ref.current) {
      mutationObserver.observe(ref.current, {
        childList: true,
        subtree: true,
      });
    }

    return () => {
      observerRef.current?.disconnect();
      mutationObserver.disconnect();
    };
  }, [setupObserver]);

  return ref;
}
